var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.source)?_c('img',{class:{ clickable: _vm.clickable },attrs:{"src":_vm.source,"alt":"image"},on:{"click":_vm.openImage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }